var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L21 21",
    stroke: "#929EAF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4 6.23005C4.96 6.56005 4.557 6.90805 4.19 7.26205C2.96435 8.4524 1.94961 9.84213 1.189 11.372C1.09429 11.5677 1.04509 11.7822 1.04509 11.9995C1.04509 12.2169 1.09429 12.4314 1.189 12.627C1.94921 14.1572 2.96362 15.5473 4.189 16.738C5.94 18.423 8.518 20 12 20C14.236 20 16.1 19.35 17.61 18.438L13.666 14.495C13.0889 14.8805 12.396 15.054 11.7054 14.9859C11.0147 14.9179 10.3691 14.6124 9.87833 14.1217C9.38761 13.631 9.08219 12.9853 9.01412 12.2947C8.94605 11.604 9.11952 10.9111 9.505 10.334L5.401 6.22905L5.4 6.23005ZM20.666 15.838C21.5163 14.8649 22.2373 13.786 22.811 12.628C22.9057 12.4324 22.9549 12.2179 22.9549 12.0005C22.9549 11.7832 22.9057 11.5687 22.811 11.373C22.0508 9.84285 21.0364 8.45278 19.811 7.26205C18.06 5.57705 15.483 4.00005 12 4.00005C11.0521 3.9973 10.108 4.11935 9.192 4.36305L20.666 15.838Z",
    fill: "#929EAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.29a79f87eb1e92ea03670a81109b46af.svg";
export { ForwardRef as ReactComponent };